import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '../router'
import global from '@/Global'

// create an axios instance
const service = axios.create({
  baseURL: global.baseURL, // process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})
// request interceptor
service.interceptors.request.use(

  config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['hxUserLoginKey'] = getToken()
    }
    config.withCredentials = true // 解决跨域cookie问题
    // console.log(config)
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */

  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    // console.log(response)
    if (res.code === 2001 || (res.code === -1 && res.msg =='获取用户失败')) {
      // 重新登陆
      console.log('重新登陆')
     // router.push({path: '/login'})
      // window.location.href = '/'
      store.dispatch('user/resetToken').then(() => {
        location.reload()
      })
    }
    if (res.code !== 0 && res.code !== 20000 && res.code !== 100) {
      Message({
        message: res.me || res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 如果客户代码是100 是业务提示
      /*
      if (res.code == 100) {
        return res
      }
      */
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014 ) {
        // to re-login
        MessageBox.confirm('登陆失效！你可以点击取消停留在改页面，或者点击重新登录', '提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    if (error['response'] && error['response']['data']) {
      responseError(error['response']);
    } else {
      messageAlert('error', '无法访问服务器，请检查网络');
    }
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)
async function responseError(response) {
  let err = response.status
  switch (err) {
    case 401:
      messageAlert('error', '未授权,请重新登陆!')
      break;
    case 403:
      messageAlert('error', '您没权限访问该页面!')
      break;
    case 404:
      messageAlert('error', '找不到该页面访问的地址!')
      break;
    case 405:
      messageAlert('error', '请求方法错误!')
      break;
    case 500:
      // eslint-disable-next-line no-case-declarations
      messageAlert('error', '页面内部错误，请联系管理员')
      break
    case 502:
      messageAlert('error', "502，(错误网关) 服务器作为网关或代理，从上游服务器收到无效响应!")
      break;
    case 503:
      messageAlert('error', '503，(服务不可用) 服务器目前由于超载、停机维护或网络不可用等情况无法使用!')
      break;
    case 504:
      messageAlert('error', '504，(网关超时) 服务器作为网关或代理，但是没有及时从上游服务器收到请求!')
      break;
    case 505:
      messageAlert('error', '505，(HTTP 版本不受支持) 服务器不支持请求中所用的 HTTP 协议版本!')
      break;
    default:
      messageAlert('error', response['data']['error_description'])
      break;
  }
}

async function messageAlert(type = 'success', msg = '', duration = 8000) {
  Message({
    showClose: true,
    type: type,
    message: msg,
    duration: duration
  })
}
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js